<template>
  <div class="wrap">
    <div style="overflow: hidden;">
      <top-nav :class="$route.name=='dashboard'?'dashboard-header':''"></top-nav>
    </div>
    <div style="min-height: 400px;margin-top:170px;">
      <router-view></router-view>
    </div>
    <bottom-footer :class="$route.name=='dashboard'?'dashboard-footer':''"></bottom-footer>
    <!-- <div class="modal fade" id="verifyModal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document" style="width: 385px;top: 50%;margin-top: -140px;">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title">请完成安全验证</h4>
          </div>
          <div class="modal-body">
            <div class="verify-wrap" id="verify-wrap"></div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import TopNav from './topNav';
import BottomFooter from './footer';
export default {
  components: {TopNav, BottomFooter},
  mounted () {
    // this.initSlideVerify();
  },
  data () {
    return {
      slideVerify: null
    }
  },
  computed: {
  },
  methods: {
    initSlideVerify () {
      const SlideVerifyPlug = window.slideVerifyPlug;
      this.slideVerify = new SlideVerifyPlug('#verify-wrap', {
        wrapWidth: '350', // 设置 容器的宽度 ,不设置的话，会设置成100%，需要自己在外层包层div,设置宽度，这是为了适应方便点；
        initText: '请向右滑动滑块', // 设置  初始的 显示文字
        sucessText: '验证通过', // 设置 验证通过 显示的文字
        getSuccessState: this.slideSuccess
      });
    },
    slideSuccess (res) {
      const _self = this;
      // 当验证完成的时候 会 返回 res 值 true，只留了这个应该够用了
      if (_self.slideVerify.slideFinishState) {
        _self.$store.commit('request');
        setTimeout(function () {
          $('#verifyModal').modal('hide');
          _self.slideVerify.resetVerify(); // 可以重置 插件 回到初始状态
        }, 300);
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .wrap {
    .fixed-right-bar{
      position: fixed;
      top: 50%;
      margin-top: -182px;
      right: 0;
      z-index: 10000;
      background: none;
      box-shadow: none;
      ul {
        width: 60px;
        height: 204px;
        background: #fff;
        box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.10);
        margin-top: 15px;
      }
      li {
        cursor: pointer;
        width: 60px;
        height: 68px;
        position: relative;
        color: #333333;
        text-align: center;
        padding-top: 15px;
        transition-duration: .4s;
        .fa {
          display: block;
          transition-duration: .4s;
        }
        a {
          color: #333333;
          font-size: 10px;
          text-decoration: none;
        }
        .building {
          display: none;
          width: 135px;
          height: 80px;
          position: absolute;
          left: -155px;
          top: -3px;
          z-index: 999;
          background-color: #fff;
          .arrow {
            width: 30px;
            height: 30px;
            background: url(http://zjjcmspublic.oss-cn-hangzhou.aliyuncs.com/jcms_files/jcms1/web1/site/script/zjzwfw-2019/ycdtdh_pic/jt2.png) no-repeat center;
            position: absolute;
            top: 25px;
            left: 130px;
          }
          .text {
            overflow: hidden;
            width: 100%;
            height: 100%;
            box-shadow: 1px 1px 8px 1px rgba(4, 4, 4, 0.10);
          }
        }
        &:hover {
          background-color: @color-base;
          color: #ffffff;
          .fa {
            transform: rotateY(360deg);
          }
          a {
            color: #ffffff;
          }
          .building {
            display: block;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/home/index.vue